import { useAuth } from "@clerk/clerk-react";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";

import { fetcherAuth } from "utils/api";

export function useRefreshChatCredits() {
  const { getToken } = useAuth();
  const { currentOrg } = useContext(OrganizationUserContext);
  const { setSubscription } = useContext(SubscriptionContext);

  return async () => {
    if (!currentOrg?.id) return;
    try {
      const { remainingChatMessages } = await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg.id}/payments/remaining-chat-messages`,
        "GET",
      );
      setSubscription((s) => (s ? { ...s, remainingChatMessages } : s));
    } catch (error) {}
  };
}
